import * as Yup from "yup";
import checkout from "../../new-venue/schemas/form";

const {
  formField: {
    city,
    title,
    address,
    //  primaryDestinationId
  },
} = checkout;

const validations = [
  Yup.object().shape({
    [title.name]: Yup.string()
      .matches(/([A-Za-z])/, title.invalidMsg)
      .required(title.errorMsg),
    // [primaryDestinationId?.name]: Yup.string().required(primaryDestinationId.errorMsg),
  }),
  Yup.object().shape({
    [address.name]: Yup.string()
      .matches(/([A-Za-z\u0600-\u06FF])/, address.invalidMsg)
      .required(address.errorMsg),
    [city.name]: Yup.string().required(city.errorMsg),
  }),
];

export default validations;
